import { createContext, useMemo, useEffect } from 'react';
import config from '@wearetla/tla-essentials-tools/config';
import { I18nextProvider } from 'react-i18next';

// Utils
import { useStorage } from '@wearetla/tla-essentials-tools/utilities/storage';
import { setHeaders, setDefaultGetParams } from '@wearetla/tla-essentials-tools/utilities/request';
import { createI18nInstance } from '/utilities/i18n';


export const I18nContext = createContext({ language: config.i18n.defaultLanguage, setLanguage: () => {} });

export const I18nProvider = ({ children, initialLanguage }) => {
	const { language: storedLanguage, setData } = useStorage();

	const setLanguage = (slug) => {
		if (config.i18n.availableLanguages.includes(slug)) {
			setData('language', slug);
			window.location.reload();
		}
	};

	const language = useMemo(() => {
		const language = storedLanguage || initialLanguage || config.i18n.defaultLanguage;

		if(config.i18n.availableLanguages.includes(language)) {
			return language;
		}

		return config.i18n.defaultLanguage;
	}, [initialLanguage, storedLanguage])

	const i18nInstance = useMemo(() => createI18nInstance(language), []);

	setHeaders({
		language: language,
	});

	setDefaultGetParams({ language: language });


	useEffect(() => {
		if (i18nInstance.language !== language) {
			i18nInstance.changeLanguage(language);
			setHeaders({
				language: language,
			});

			setDefaultGetParams({ language: language });
			
		}
		setData('language', language);
	}, [language, i18nInstance]);

	return (
		<I18nContext.Provider value={{ language, setLanguage }}>
			<I18nextProvider i18n={i18nInstance}>
				{children}
			</I18nextProvider>
		</I18nContext.Provider>
	);
};
